// import Swiper from "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs";

const productAmount = document.querySelectorAll(
  ".products-blog__swiper-slide"
).length;
const screenWidth = window.innerWidth;
const swiper = new Swiper(".products-blog__slider", {
  slidesPerView: "auto",
  spaceBetween: 30,

  freeMode: true,
  pagination: {
    el: ".products-blog__slider-pagination",
    clickable: true,
    type: "bullets",
    renderBullet: function (index, className) {
      return '<span class="' + className + ' landing-swiper-bullet">‎</span>';
    },
  },
  navigation: {
    nextEl: ".products-blog__slider-next",
    prevEl: ".products-blog__slider-prev",
  },
});
